import React from 'react';
import { canAccessQCModule } from '../../utils/roleConstants';
import { Form, FormGroup, FormControl, Button, Modal, Row, Col } from 'react-bootstrap';
import config from '../../../config';
import DataTable from 'react-data-table-component';
import { Navigate } from 'react-router';
import ReactPaginate from 'react-paginate';
import moment from 'moment';
import utils from '../../utils';
import DataTableEllipsisText from '../../_components/DataTableEllipsisText';
import ObsoletePartNoCell from '../../_components/ObsoletePartNoCell';
import DatacoLoadingIndicator from '../../_components/DatacoLoadingIndicator';
import QValuePageHeader from '../../_components/QValuePageHeader';
import { Q_VALUE_PAGE_HEADERS } from '../../utils/qValuePageHeaders';

let perPage=30;

class IncomingMaster extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            id: 0,
            partNo: '',
            partDesc: '',
            AQL: '',
            shelfLife: '',
            skipLot: 0,
            supplier1: '',
            supplier2: '',
            supplier3: '',
            supplierMeasurement: 0,
            MPN1: '',
            MPN2: '',
            MPN3: '',
            offset: 0,
            CoC: 0,
            imgPath: '',
            company: 0,
            currentPage: 1,
            rowsPerPage: 10,
            totalRows: 0,
            loading: false,
          
        };
        this.tableRequestSeq = 0;
        this.columns = [
    {
        name: 'No',
        selector: row => row.no,
        width: '60px',
        compact: true,
    },
    {
        name: 'Part No',
        selector: row => row.partNo,
        cell: row => <ObsoletePartNoCell value={row.partNo} isObsolete={row.isPartObsolete} />,
        sortable: true,
        width: '200px',
        compact: true,
    },
     {
        name: 'Part Description',
        selector: row => row.partDesc,
        cell: row => <DataTableEllipsisText value={row.partDesc} />,
        sortable: true,
    },
    {
        name: 'Action',
        cell: (row, rowIndex) => (
              <div style={{ display: 'flex', gap: '10px', flexWrap: 'nowrap', minWidth: '200px' }}>
                <button
                    style={{ whiteSpace: 'nowrap', minWidth: '70px', padding: '6px 12px', fontSize: '14px', fontWeight: '500', flexShrink: 0 }}
                    type="button"
                    onClick={() => {
                        if (row && row.id) {
                            window.location.hash = `#/incoming_master/${row.id}`;
                      }
                      }}
                >
                    Edit
            </button>
                <button
                    style={{ whiteSpace: 'nowrap', minWidth: '70px', padding: '6px 12px', fontSize: '14px', fontWeight: '500', flexShrink: 0 }}
                    type="button"
                    onClick={() =>
                        window.confirm("Are you sure you delete this data?") && this.onDeleteProduct(null, row, rowIndex)}
                >
                    Delete
          </button>
            </div>
        ),
        ignoreRowClick: true,
        allowOverflow: true,
        width: '200px',
        minWidth: '200px',
    }];
    }

    componentWillMount() {

        this.setState({
            processes: []
        });
        const requestOptions = {
            method: 'GET',
            headers: { 'Content-Type': 'application/json' },
        };
        this.buildHtmlTable();
    }

    exportExcel() {
        utils.tableToExcel('datatable', 'masterdata', 'Incoming_Inpection_Master_' + moment().format('YYYYMMDD') + '.xls');
    };


    buildHtmlTable(page = null, limit = null) {
        const { tableStyle, tableHeader } = this.state;
        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
        };

        // Use provided page/limit or state values
        const currentPage = page !== null ? page : this.state.currentPage;
        const rowsPerPage = limit !== null ? limit : this.state.rowsPerPage;
        const offset = (currentPage - 1) * rowsPerPage;
        const requestSeq = ++this.tableRequestSeq;
        this.setState({ loading: true });

        if (localStorage.getItem('user') != null)
            return fetch(`${config.apiUrl}/getIncomingMasterByCompany?company=${JSON.parse(localStorage.getItem('user')).accountId}&keyword=${this.state.keyword || ''}&limit=${rowsPerPage}&offset=${offset}`, requestOptions)
                .then((response) => {
                    return response.text().then(text => {
                        const data = text && JSON.parse(text);

                        return data;
                    });
                })
                .then(body => {
                    if (requestSeq !== this.tableRequestSeq) return;

                    // login successful if there's a user in the response
                    let array = [];
                    const products = [];

                    // Ensure body.data exists and is an array
                    if (body && body.data && Array.isArray(body.data)) {

                        body.data.map((data, index) => {
                            array.push({
                                no: index + offset + 1,
                                id: data.id,
                                partNo: data.partNo,
                                partDesc: data.partDesc,
                                AQL: data.AQL,
                                shelfLife: data.shelfLife,
                                skipLot: data.skipLot,
                                supplier1: data.supplier1,
                                supplier2: data.supplier2,
                                supplier3: data.supplier3,
                                supplierMeasurement: data.supplierMeasurement,
                                MPN1: data.MPN1,
                                MPN2: data.MPN2,
                                MPN3: data.MPN3,
                                CoC: data.CoC,
                                imgPath: data.imgPath,
                                company: data.company,
                                isPartObsolete: data.isPartObsolete === true || data.isPartObsolete === 1 || data.isPartObsolete === '1'
                            })
                        });

                        this.setState({ 
                            products: array,
                            body: body.data,
                            totalRows: body.meta && body.meta.total_count ? body.meta.total_count : 0,
                            currentPage: currentPage,
                            rowsPerPage: rowsPerPage,
                            offset: offset,
                            loading: false
                        });
                    } else {
                        // Handle case where response structure is different
                        this.setState({ 
                            products: [],
                            body: [],
                            totalRows: 0,
                            loading: false
                        });
                    }
                })
                .catch(error => {
                    if (requestSeq !== this.tableRequestSeq) return;

                    console.error('Error fetching incoming master data:', error);
                    this.setState({ 
                        products: [],
                        body: [],
                        pageCount: 1,
                        loading: false
                    });
                });
    }


    onDeleteProduct(cell, row, rowIndex) {
        // cell parameter is not used but kept for compatibility
        fetch(`${config.apiUrl}/deleteIncomingMaster`, {
            method: "post",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },

            //make sure to serialize your JSON body
            body: JSON.stringify({
                id: row && row.id ? row.id : (this.state.body && this.state.body[rowIndex] ? this.state.body[rowIndex].id : null),
            })
        })
            .then((response) => {
                if (response.status == 200) {
                    window.alert('Deleted Successfully.');
                    this.buildHtmlTable();
                }
            });
    }

    handlePageChange = (page) => {
        this.setState({ currentPage: page }, () => {
            this.buildHtmlTable(page, this.state.rowsPerPage);
        });
    };

    handleRowsPerPageChange = (newRowsPerPage, page) => {
        this.setState({ rowsPerPage: newRowsPerPage, currentPage: page }, () => {
            this.buildHtmlTable(page, newRowsPerPage);
        });
    };


     handleChange (event, newValue) {
        this.setState({ tabvalue: newValue });
    }

      
    render() {
        const user = JSON.parse(localStorage.getItem('user'));
        if (!canAccessQCModule(user)) {
            return <Navigate to='/' />
        }
        let { keyword,products, } = this.state;


        return (
            <div class="container">
                <QValuePageHeader {...Q_VALUE_PAGE_HEADERS.incoming_master} />
                <div style={{ 
                    marginBbottom: '20em', 
                    position: 'relative', 
                    minHeight: '50px',
                    padding: '16px',
                    margin: '16px 0'
                }}>
                    <div style={{ 
                        display: 'flex', 
                        alignItems: 'center', 
                        gap: '10px', 
                        flexWrap: 'wrap',
                        padding: '12px'
                    }}>
                        <FormGroup controlId="formInlineName">
                            <FormControl type="text" onChange={ev => { this.setState({ keyword: ev.target.value }) }} value={keyword} />
                        </FormGroup>
                        <Button
                            bsStyle="primary"
                            onClick={e => {
                                this.setState({ currentPage: 1, offset: 0 }, () => {
                                    this.buildHtmlTable(1, this.state.rowsPerPage);
                                });
                            }}>Search</Button>
                        <Button
                            bsStyle="primary"
                            onClick={e => this.exportExcel()}>Export</Button>
                        <Button
                            bsStyle="danger"
                            onClick={e => { window.location.hash = '#/incoming_master/new';
                        }}>New</Button>
                    </div>
                    <a id='dlink' style={{ display: 'none' }}></a>
                </div>
                <div id="datatable" class="container" style={{ overflowY: 'auto' }} >
                  <DataTable
                    columns={this.columns}
                    data={products || []}
                    progressPending={this.state.loading}
                    progressComponent={<DatacoLoadingIndicator loading={this.state.loading} size="compact" label="Loading incoming master data" />}
                    pagination
                    paginationServer
                    paginationTotalRows={this.state.totalRows}
                    paginationPerPage={this.state.rowsPerPage}
                    paginationDefaultPage={this.state.currentPage}
                    onChangePage={this.handlePageChange}
                    onChangeRowsPerPage={this.handleRowsPerPageChange}
                    highlightOnHover
                />
                </div>
            </div>

        );
    }
}

export { IncomingMaster };
